import { Component, EventEmitter, Input, input, Output } from '@angular/core';
import { NavigationItemComponent } from "../navigation-item/navigation-item.component";
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationItem } from '../models/navigation-item.model';

@Component({
  selector: 'app-navigation-item-group',
  imports: [NavigationItemComponent, CommonModule, TranslateModule],
  templateUrl: './navigation-item-group.component.html',
  styleUrl: './navigation-item-group.component.css'
})
export class SidebarItemGroupComponent {

  groupTitle = input<string | null | undefined>(null);
  @Input() classes: string = '';


  items = input<NavigationItem[]>([]);

  minimized = input<boolean>(false);

  @Output() activated = new EventEmitter<{title: string, icon: string}>();

  onActive = (title: string, icon: string) => {
    if (title) {
      this.activated.emit({title, icon});
    }
  }
}
